import { PropsWithChildren } from 'react';

import { useTimelineEventContext } from '@components/patterns/Timeline/context';
import { Spinner } from '@components/primitives/Spinner';

import css from './styles.module.css';

export type TimelineIconProps = PropsWithChildren;

/**
 * The event's icon, in its variant-coloured circle. A pending event shows a
 * spinner instead, so callers do not have to special-case one.
 */
export function TimelineIcon({ children }: TimelineIconProps) {
  const { variant } = useTimelineEventContext();

  return (
    <div className={css.icon} aria-hidden>
      {variant === 'pending' ? <Spinner className={css.spinner} /> : children}
    </div>
  );
}
